<template>
  <van-card
    :desc="data[descField]"
    class="article-item"
    :class="size"
    @click="onClick(data)"
  >
    <div class="thumb" slot="thumb">
      <img
        v-if="data[imgField]"
        :src="config.fileUrl + '/' + data[imgField]"
        alt=""
      />
      <span v-else class="avatar"><van-icon name="photo-o"/></span>
    </div>
    <div class="title" slot="title">
      {{ data[titleField] }}
    </div>
    <div slot="tags">
      <div v-if="dateField" class="text-less" style="font-size:0.3rem;">
        {{ data[dateField] }}
      </div>
    </div>
    <div v-if="$slots.desc" slot="desc">
      <slot name="desc"></slot>
    </div>
  </van-card>
</template>

<script>
import { Card, Icon } from "vant";
import config from "@/config/baseConfig";

export default {
  components: {
    [Card.name]: Card,
    [Icon.name]: Icon,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    titleField: {
      type: String,
      default: "Name",
    },
    descField: {
      type: String,
      default: "Desc",
    },
    dateField: {
      type: String,
      default: "",
    },
    imgField: {
      type: String,
      default: "ImgUrl",
    },
    size: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      config,
    };
  },
  methods: {
    onClick(data) {
      this.$emit("click", data);
    },
  },
};
</script>

<style lang="less" scoped>
.article-item {
  .title {
    font-weight: bold;
    font-size: 0.4rem;
  }
  .van-card__thumb {
    width: 1.7rem;
    height: 1.7rem;
  }
  .van-card__content {
    min-height: 1.7rem;
  }
  .thumb {
    height: 100%;
    img {
      width: 100%;
    }
  }
  .avatar {
    display: inline-block;
    width: 100%;
    height: 100%;
    background: #f1f1f1;
    text-align: center;
    line-height: 1.7rem;
    color: #999;
    font-size: 20px;
    border-radius: 4px;
  }
  &.small {
    .title {
      font-weight: 500;
      font-size: 0.4rem;
    }
    .van-card__thumb {
      width: 1.2rem;
      height: 1.2rem;
    }
    .van-card__content {
      min-height: 1.2rem;
    }
    .avatar {
      line-height: 1.2rem;
    }
  }
  &.van-card {
    background: #fff;
  }
}
</style>
